import React from "react"; 

const If = (props) => {
  let component = null;
  if (props.condition) {
    component = props.then;
  } else if (
    (typeof props.elseCondition === "undefined" || props.elseCondition) &&
    props.else
  ) {
    component = props.else;
  }

  return component;
};

export default If;
